module.exports = __webpack_public_path__ + "img/inductrialInjuryPrevention_3.d99229a6.png";